export const BILLING_BLOCKED_EVENT = 'frameon:billing-blocked';

export type BillingBlockCode = 'PLAN_REQUIRED' | 'CREDITS_EXHAUSTED';

export interface BillingBlock {
  code: BillingBlockCode;
  message: string;
}

export function billingBlockCode(status: number, code: unknown): BillingBlockCode | null {
  return status === 402 && (code === 'PLAN_REQUIRED' || code === 'CREDITS_EXHAUSTED') ? code : null;
}

export function announceBillingBlock(block: BillingBlock) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<BillingBlock>(BILLING_BLOCKED_EVENT, { detail: block }));
}
